// Mini Cart Discount Codes
let discountCode = "";
let miniCart = document.querySelector('#shopify-section-mini-cart');
miniCart?.addEventListener('input', (e) => {
    if(e.target.id == 'discount_code') {
        discountCode = e.target.value;
    }
  });
miniCart?.addEventListener('click', (e) => {
    if(e.target.id == 'apply_discount') {
        e.target.innerHTML = 'APPLYING';
        e.target.disabled = true;
        applyDiscount(discountCode, e.target);
    }
})
function applyDiscount(code, sourceElement) {
    // Whether Shopify actually evaluated the code. A failed request means the
    // code was never assessed, which is a different fact from "Shopify said no"
    // and must not be reported as a rejection. Observed for real: `shopify theme
    // dev` does not proxy /discount/ and returns 401, which made every code look
    // rejected on the local server.
    var discountRequestOk = false;
    var discountStatus = 0;

    fetch(`/discount/${code}`)
    .then(function(response) {
        discountRequestOk = response.ok;
        discountStatus = response.status;
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            updates: {},
            }),
        });
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
        // discount_codes is Shopify's own verdict on the entered code, whatever
        // it discounts. cart_level_discount_applications is not: product-level
        // codes are allocated to line items and free-shipping codes to no cart
        // field at all, so reading it reported accepted codes as rejected.
        // /discount/ answers 200 even for codes that don't exist, so the
        // response status can't stand in for this either.
        var codes = (cart && cart.discount_codes) || [];
        var applied = codes.some(function(discount) {
            return discount.applicable === true
                && String(discount.code || '').toUpperCase() === String(code).toUpperCase();
        });
        var outcome = applied ? 'applied' : (discountRequestOk ? 'rejected' : 'error');
        (sourceElement || document.documentElement).dispatchEvent(new CustomEvent("discount:result", {
            bubbles: true,
            detail: { code: code, outcome: outcome, http_status: discountStatus }
        }));
        // The analytics cart cache (assets/analytics.js) is refreshed ONLY by
        // cart:updated; cart:refresh (dispatched in .finally() below) just
        // tells the theme's CartDrawer to swap HTML and produces no cart
        // payload. Without this dispatch, checkout_clicked keeps reporting
        // pre-discount has_discount/cart_value_cents for the rest of the page.
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart: cart }
        }));
    })
    .finally(function() {document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }),);})
    .catch(error => console.error('Error:', error));
};
// Page has loaded and theme assets are ready
window.addEventListener('pageshow', function() {
    // console.log('Page loaded and theme assets are ready')
    var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
    if (isBrowser() && !navigator.userAgent.includes("Linux x86_64")) {
        // tracking script
    }
});
